export const DOCUMENTS_BASE_PATH = 'document';
